import { Event } from '@types'
import React, { useState } from 'react'
import CardContent from '../Itinerary/Card/CardContent'
import ViewEventModal from '../Itinerary/ViewEventModal'

interface ReadOnlyCardProps {
	event: Event
}

const ReadOnlyCard: React.FC<ReadOnlyCardProps> = ({ event }) => {
	const [isModalOpen, setIsModalOpen] = useState(false)

	return (
		<>
			<CardContent
				event={event}
				onClick={() => setIsModalOpen(true)}
				containerProps={{ style: { cursor: 'pointer' } }}
			/>
			<ViewEventModal
				isOpen={isModalOpen}
				onClose={() => setIsModalOpen(false)}
				event={event}
			/>
		</>
	)
}

export default ReadOnlyCard
